import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { NaverTop } from "../../components/top/Top";
import { ShopExistView } from "./components/ShopExistView";
import { ShopNotExistView } from "./components/ShopNotExistView";
import { PageContainer, PageContentContainer } from "../../components/common";
import { useIsConnected } from "views/naver/hooks/useIsConnected";
import { fn_bridge_naver_login_exit } from "function/FnPosBridge";

interface Props {
  rootStore?: any;
}

const NaverDisconnectedView = inject("rootStore")(
  observer(({ rootStore }: Props) => {
    const { hasConnectableShops, isLoading } = useIsConnected(rootStore);
    if (isLoading) return <div></div>;

    useEffect(() => {
      fn_bridge_naver_login_exit(rootStore, "HIDE"); // 배달매니저 이동 버튼 삭제 호출
    },[])

    return (
      <>
        <NaverTop title="네이버 주문 연동" />
        <PageContainer>
          <PageContentContainer>{hasConnectableShops ? <ShopExistView rootStore={rootStore} /> : <ShopNotExistView rootStore={rootStore} />}</PageContentContainer>
        </PageContainer>
      </>
    );
  })
);

export default NaverDisconnectedView;
